import { AppState, AppTypes, SET_TRUCK, LOAD_DATA_REQUEST, LOAD_DATA_FAIL, LOAD_DATA_SUCCESS, SET_VIEWER_API, SET_SIMULATION_SELECT, SET_ACTIVE_SIMULATION, SET_ACTIVE_SIMULATION_STEP, SET_ACTIVE_SIMULATION_TYPE, SET_SIMULATION_SIDE_ACTIVE, END_ACTIVE_SIMULATION, RESTART_SIMULATION, SET_POSITION_READY, GO_TO_NEXT_SIMULATION, SET_AVSP, SET_CONTENT_OPENED, SET_NEXT_SIM_STEP } from "../types/app";
import { isWebglSupport } from "../lib/support";
import { GUIDE_DIALOG, END_DIALOG, REMOTE_SIMULATION } from "constants/sumilationConstants";
import { getActiveSteps } from "selectors/commonSelectors";

const initialState: AppState = {
  loading: false,
  error: false,
  webglError: !isWebglSupport(),
  sceneLoading: false,
  sceneLoadingProgress: 0,
  simulationSelectActive: false,
  activeSimulationStep: 0,
  simulationSidePanelActive: false,
  activeDialogType: GUIDE_DIALOG,
  positionReady: false,
  afterLeverAnimationProgress: false,
  contentOpened: false
}

export default (
  state = initialState,
  action: AppTypes
): AppState => {
  switch(action.type) {
    case LOAD_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload
      }

    case LOAD_DATA_REQUEST:
      return {
        ...state,
        loading: true
    }

   case SET_AVSP: 
      return {
        ...state,
        afterLeverAnimationProgress: action.payload
      }

    case SET_VIEWER_API: 
      return {
        ...state,
        viewerApi: action.viewerApi
      }

    case LOAD_DATA_FAIL:
      return {
        ...state,
        loading: false,
        error: true
      }   

    case SET_POSITION_READY: 
      return {
        ...state,
        positionReady: action.payload
      }

    case SET_SIMULATION_SIDE_ACTIVE:
      return {
        ...state,
        simulationSidePanelActive: action.payload        
      }    

    case SET_TRUCK:
      return {
        ...state,
        truck: action.payload
      }    

    case END_ACTIVE_SIMULATION:
      return {
        ...state,
        activeDialogType: END_DIALOG
      }
      
    case SET_SIMULATION_SELECT:
      return {
        ...state,
        simulationSelectActive: action.simulationSelectActive,
      }
      
    case RESTART_SIMULATION: 

      state.viewerApi!.Simulations!.getSimById(state.activeSimulation!.id).reset()

      return {
        ...state,
        activeSimulation: state.activeSimulation,
        activeDialogType: GUIDE_DIALOG,
        positionReady: true,
        activeSimulationStep: 0,
        //@ts-ignore
        activeSimulationType: state.activeSimulation ? state.activeSimulation.firstPosSimType : REMOTE_SIMULATION,
        restartKey: Date.now()
      }
      
    case GO_TO_NEXT_SIMULATION: 
      const activeSimByTruck = state.data!.simulations
        .find(item => item.truck === state.truck!.name)!.list
          
      const indexOfTargetSim = activeSimByTruck
        .map((item) => item.id)
        .indexOf(state.activeSimulation!.id) + 1

      const targetSim = activeSimByTruck[indexOfTargetSim]
      
      return {
        ...state,
        activeSimulation: targetSim,
        activeDialogType: GUIDE_DIALOG,
        positionReady: false,
        activeSimulationStep: 0,
        lastActiveSimulation: targetSim,
        // //@ts-ignore
        activeSimulationType: targetSim ? targetSim.firstPosSimType : REMOTE_SIMULATION,
      }

    case SET_ACTIVE_SIMULATION: 
      console.log(action.payload && action.payload.firstPosSimType)
    
      return {
        ...state,
        activeSimulation: action.payload,
        activeDialogType: GUIDE_DIALOG,
        positionReady: false,
        activeSimulationStep: 0,
        lastActiveSimulation: action.payload ? action.payload : state.lastActiveSimulation,
        //@ts-ignore
        activeSimulationType: action.payload ? action.payload.firstPosSimType : REMOTE_SIMULATION
      }

    case SET_ACTIVE_SIMULATION_STEP: 
    return {
        ...state,
        activeSimulationStep: action.payload
      }

    case SET_ACTIVE_SIMULATION_TYPE: 
      return {
        ...state,
        activeSimulationType: action.payload,
        activeSimulationStep: 0
      }

    case SET_CONTENT_OPENED:
      return {
        ...state,
        contentOpened: action.payload
      }

    case SET_NEXT_SIM_STEP: 
      const steps = getActiveSteps({app: state})
    
      if(steps) {
        if(state.activeSimulationStep !== steps.length - 1) {
          return {
            ...state,
            activeSimulationStep: state.activeSimulationStep + 1,
            contentOpened: true,
          }
        } else {
          return {
            ...state,
            activeSimulationType: REMOTE_SIMULATION,
            activeSimulationStep: 0,
            
          }
        }
        
      } else {
        return {
          ...state
        }
      }

    default: 
      return state 
  }
}
